import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { isValidAmount, isValidAmountWithMax } from '../../utils/utils'

export const getEarnDepositValidationSchema = (
  t: TFunction<'translation', undefined>,
  maxAmount: string
) =>
  yup.object().shape({
    currency: yup.string().required(t('earn.depositSheet.currencyRequired')),
    allocateFrom: yup
      .object({
        value: yup.string().required(t('earn.depositSheet.allocateFromRequired')),
        name: yup.string().required(t('earn.depositSheet.allocateFromRequired')),
      })
      .nullable()
      .required(t('earn.depositSheet.allocateFromRequired')),
    amount: yup
      .string()
      .required(t('earn.depositSheet.amountRequired'))
      .test('is-valid-amount', t('earn.depositSheet.amountInvalid'), isValidAmount)
      .test('max-amount', t('earn.depositSheet.amountExceedsMax'), value => {
        // isValidAmountWithMax treats a '0' maxAmount as "no max" and passes any value, but for
        // a wallet with a genuine zero balance there is nothing valid to deposit.
        if (maxAmount === '0') return false
        return isValidAmountWithMax(value, maxAmount)
      }),
    termsAccepted: yup
      .boolean()
      .oneOf([true], t('earn.depositSheet.termsAcceptedRequired'))
      .required(t('earn.depositSheet.termsAcceptedRequired')),
  })

export const getEarnWithdrawValidationSchema = (
  t: TFunction<'translation', undefined>,
  getMaxAmount: () => string
) =>
  yup.object().shape({
    currency: yup.string().required(t('earn.withdrawSheet.currencyRequired')),
    withdrawToWallet: yup
      .object({
        value: yup.string().required(t('earn.withdrawSheet.walletRequired')),
        name: yup.string().required(t('earn.withdrawSheet.walletRequired')),
      })
      .nullable()
      .required(t('earn.withdrawSheet.walletRequired')),
    amount: yup
      .string()
      .required(t('earn.withdrawSheet.amountRequired'))
      .test('is-valid-amount', t('earn.withdrawSheet.amountInvalid'), isValidAmount)
      .test('max-amount', t('earn.withdrawSheet.amountExceedsMax'), value => {
        // Read the max amount lazily (rather than closing over a snapshot) so validation always
        // uses the latest fetched balance without needing to rebuild the schema/resolver.
        const maxAmount = getMaxAmount()
        // isValidAmountWithMax treats a '0' maxAmount as "no max" and passes any value, but with
        // a genuinely zero withdrawable balance there is nothing valid to withdraw.
        if (maxAmount === '0') return false
        return isValidAmountWithMax(value, maxAmount)
      }),
  })
